module.exports = __webpack_public_path__ + "static/media/Flag_of_Slovakia.f430be3d.svg";